'use strict';

export default function NavSizeService($state, RenderService) {
  return {
    isLarge: isLarge,
    isSmall: isSmall
  };

  function isLarge() {
    return (
      $state.current.data &&
      $state.current.data.navState === 'edit' &&
      RenderService.site &&
      RenderService.site.group === 'mobile'
    );
  }

  function isSmall() {
    return !isLarge();
  }
}

NavSizeService.$inject = ['$state', 'RenderService'];
